import React, { useEffect, useState } from 'react';
import Navbar from '../Navbar';
import { Link, useNavigate } from 'react-router-dom';
import {Box, Button,Grid, Hidden, TextField, Typography} from '@mui/material';
import swal from 'sweetalert';
import axios from 'axios';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import _ from "lodash";
import Swal from 'sweetalert2';
import BootstrapTable from 'react-bootstrap-table-next';
import 'bootstrap/dist/css/bootstrap.min.css';
import paginationFactory from 'react-bootstrap-table2-paginator';
import 'react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css';

import filterFactory,{textFilter, selectFilter} from 'react-bootstrap-table2-filter';
import overlayFactory from 'react-bootstrap-table2-overlay';
import {
  createTheme,
  PaletteColorOptions,
  ThemeProvider,
} from '@mui/material/styles';
import { Stack } from '@mui/material';

function ShowSerial() {
  const [loading, setLoading] = useState(true);
  const [seriallist, setseriallist] = useState([true]);


  useEffect(()=>{
      axios.get(`api/show_serial`).then(res=>{
          if(res.status === 200){
            setseriallist(res.data.SerialMaster);
          }
          setLoading(false);
      });
  },[]);

  const deleteUser = (e, id) => {

    e.preventDefault();
    let userId = localStorage.getItem("auth_id");
    console.log(userId);
    const data= {user_id:userId,};
    const thisClicked = e.currentTarget;
   // let userId = localStorage.getItem("auth_id");
    //console.log(userId);
   
        const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger'
      },
      buttonsStyling: true
    })
        
        swalWithBootstrapButtons.fire({
          title: 'Are you sure , you want to delete this Details',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes,delete it!',
          confirmButtonColor: "#D10000",
          cancelButtonColor:"#00D100",
          cancelButtonText: 'No, cancel!',
          reverseButtons: true
        }).then((result) => {
          if (result.isConfirmed) {
    

            axios.post(`api/destroy_serial/${id}`,data).then(res=>{
              if(res.data.status === 200){
            thisClicked.closest("tr").remove();
          }
          else if(res.data.status===404){
            swal("Success",res.data.message,"success");
            thisClicked.innerText = "Delete";
      
          }
         });
            swalWithBootstrapButtons.fire(
              
              'Deleted!',
              'serial deleted successfully.',
              'success'
            )
          } else if (
            
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
          }
        })
    
      }

      const { palette } = createTheme();
      const { augmentColor } = palette;
      const createColor = (mainColor) => augmentColor({ color: { main: mainColor } });
      const theme = createTheme({
        palette: {
          anger: createColor('#F40B27'),
          apple: createColor('#A38A00'),
          steelBlue: createColor('#5C76B7'),
          violet: createColor('#BC00A3'),
        },
        button: { // Here is where you can customise the button
          fontSize: 16,
          fontWeight: 1700,
        }, 
      });
  
  
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      . Showing {from} to {to} of {size} Results"
    </span>
  );

  const options = {
    paginationSize: 4,
    pageStartIndex: 1,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "5",
        value: 5,
      },
      {
        text: "10",
        value: 10,
      },
      {
        text: "All",
        value: seriallist.length,
      },
    ], // A numeric array is also available. the purpose of above example is custom the text
  };
 
const columns = [
  {
    dataField: "id",
    text: "ID",
  },
  {
    dataField: "series_name",
    text: "series_name",
  },
  {
    dataField: "starting_month",
    text: "starting_month",
  },
  {
    dataField: "end_month",
    text: "end_month",
    
  },
  
  {
    dataField: 'action',
    text: 'Actions',
    formatter:  (cell, row, rowIndex, formatExtraData) => { 
      const serialmaster_id= row.id;
      return (
        <ThemeProvider theme={theme}>
        <Grid container spacing={2}>
        <Grid item xs={3}>

        <Button component={Link} to={`/certificates/view_serial/${serialmaster_id}`} color="apple" size="medium" startIcon={<VisibilityIcon color='inherit'/>}/>
          </Grid>
           <Grid item xs={3}>
          <Button component={Link} to={`/certificates/edit_serial/${serialmaster_id}`} color="apple" size="medium" startIcon={<EditIcon color='inherit'/>}/>
         
          </Grid>
          <Grid item xs={3}>
          <Button onClick={(e) => deleteUser(e, serialmaster_id)}  color="primary" size="medium" startIcon={<DeleteIcon color='error'/>}/>
          </Grid>
           </Grid>
           </ThemeProvider>
      )
    },
  },
];


return (
  <div>
    <Navbar/>
    <div className = "card px-8 m-5">
      <div className = "card-header">
      <div class="d-flex justify-content-between">
           <h4>Serial Details
           </h4>
           <ThemeProvider theme={theme}>
           <Button component={Link} to="/certificates/store" variant='contained' color='apple'>Add Serial</Button>
          
           </ThemeProvider>
      </div>
      </div>
      <BootstrapTable keyField='id' data={seriallist} columns={columns} hover condensed
        // pagination={paginationFactory(options)}
        filter={filterFactory()}
        overlay={ overlayFactory() }
  
  
      
    />
  </div>
  </div>
  
)
}


export default ShowSerial


// import React, { useEffect, useState } from 'react';
// import Navbar from '../Navbar';
// import { Link, useNavigate } from 'react-router-dom';
// import {Box, Button,Grid, Hidden, TextField, Typography} from '@mui/material';
// import swal from 'sweetalert';
// import axios from 'axios';
// import EditIcon from '@mui/icons-material/Edit';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import DeleteIcon from '@mui/icons-material/Delete';
// import _ from "lodash";
// // import * as swal from 'sweetalert';
// import Swal from 'sweetalert2';
// import BootstrapTable from 'react-bootstrap-table-next';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import paginationFactory from 'react-bootstrap-table2-paginator';
// import 'react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css';

// import filterFactory,{textFilter, selectFilter} from 'react-bootstrap-table2-filter';
// import overlayFactory from 'react-bootstrap-table2-overlay';
// import {
//   createTheme,
//   PaletteColorOptions,
//   ThemeProvider,
// } from "@mui/material/styles";
// import { Stack } from "@mui/material";

// function ShowSerial() {

//   //useState declarations
//   const [loading, setLoading] = useState(true);
//   const [categorylist, setCategorylist] = useState([]);


//   useEffect(()=>{
//       axios.get(`api/show_serial`).then(res=>{
//           if(res.status === 200){
//               setCategorylist(res.data.serialmaster);
//           }
//           setLoading(false);
//       });
//   },[]);

//   //colour palette
//   const { palette } = createTheme();
//   const { augmentColor } = palette;
//   const createColor = (mainColor) =>
//     augmentColor({ color: { main: mainColor } });
//   const theme = createTheme({
//     palette: {
//       anger: createColor("#F40B27"),
//       apple: createColor("#A38A00"),
//       steelBlue: createColor("#5C76B7"),
//       violet: createColor("#BC00A3"),
//     },
//     button: {
//       // Here is where you can customise the button
//       fontSize: 16,
//       fontWeight: 1700,
//     },
//   });

//   function add3Dots(string, limit) {
//     var dots = "...";
//     if (string.length > limit) {
//       // you can also use substr instead of substring
//       string = string.substring(0, limit) + dots;
//     }

//     return string;
//   }


//   const deleteUser = (e, id) => {

//     e.preventDefault();

//     const thisClicked = e.currentTarget;

//     const swalWithBootstrapButtons = Swal.mixin({
//       customClass: {
//         confirmButton: "btn btn-success",
//         cancelButton: "btn btn-danger",
//       },
//       buttonsStyling: true,
//     });

//     swalWithBootstrapButtons
//       .fire({
//         title: "Are you sure , you want to delete this customer",
//         text: "You won't be able to revert this!",
//         icon: "warning",
//         confirmButtonColor: "#D10000",
//         cancelButtonColor: "#00D100",
//         showCancelButton: true,
//         confirmButtonText: "Yes,delete it!",
//         cancelButtonText: "No, cancel!",
//         reverseButtons: true,
//       })
//       .then((result) => {
//         if (result.isConfirmed) {
//           axios.get(`api/delete_customer/${id}`).then((res) => {
//             if (res.data.status === 200) {
//               thisClicked.closest("tr").remove();
//             } else if (res.data.status === 404) {
//               swal("Success", res.data.message, "success");
//               thisClicked.innerText = "Delete";
//             }
//           });
//           swalWithBootstrapButtons.fire(
//             "Deleted!",
//             "Customer deleted successfully.",
//             "success"
//           );
//         } else if (
//           /* Read more about handling dismissals below */
//           result.dismiss === Swal.DismissReason.cancel
//         ) {
//           // swalWithBootstrapButtons.fire(
//           //   'Cancelled',
//           //   'Your imaginary file is safe :)',
//           //   'error'
//           // )
//         }
//       });
//   };

//   //pagination
//   const customTotal = (from, to, size) => (
//     <span className="react-bootstrap-table-pagination-total">
//       . Showing {from} to {to} of {size} Results"
//     </span>
//   );

//   const options = {
//     paginationSize: 4,
//     pageStartIndex: 1,
//     // alwaysShowAllBtns: true, // Always show next and previous button
//     // withFirstAndLast: false, // Hide the going to First and Last page button
//     // hideSizePerPage: true, // Hide the sizePerPage dropdown always
//     // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
//     firstPageText: "First",
//     prePageText: "Back",
//     nextPageText: "Next",
//     lastPageText: "Last",
//     nextPageTitle: "First page",
//     prePageTitle: "Pre page",
//     firstPageTitle: "Next page",
//     lastPageTitle: "Last page",
//     showTotal: true,
//     paginationTotalRenderer: customTotal,
//     disablePageTitle: true,
//     sizePerPageList: [
//       {
//         text: "5",
//         value: 5,
//       },
//       {
//         text: "10",
//         value: 10,
//       },
//       {
//         text: "All",
//         value: categorylist.length,
//       },
//     ], // A numeric array is also available. the purpose of above example is custom the text
//   };
//   var add = add3Dots("address", 25);
//   const ans = add3Dots("address", 25);

//   //columns of table
//   const columns = [
//     {
//           dataField: "id",
//           text: "ID",
//         },
//         {
//           dataField: "series_name",
//           text: "series_name",
//         },
//         {
//           dataField: "starting_month",
//           text: "starting_month",
//         },
//         {
//           dataField: "end_month",
//           text: "end_month",
          
//         },
//     {
//       dataField: 'action',
//       text: 'Actions',
//       formatter:  (cell, row, rowIndex, formatExtraData) => { 
//         // console.log(row);
//         const customerId = row.id;
//         // console.log(customerId);


//         return (
//           <ThemeProvider theme={theme}>
//           <Grid container spacing={2}>
//           <Grid item xs={3}>

//            <Button component={Link} to={`/view-customer/${customerId}`} color="apple" size="medium" startIcon={<VisibilityIcon color='inherit'/>}/>
//           </Grid>
//            <Grid item xs={3}>
//           <Button component={Link} to={`/edit-customer/${customerId}`} color="apple" size="medium" startIcon={<EditIcon color='inherit'/>}/>
//           {/* <td><Link to={`edit-customer/${item.id}`} className="btn btn-success btn-sm">Edit</Link></td> */}
//           {/* <td><button type="button" onClick={(e) => deleteUser(e, item.id)} className="btn btn-danger bt-sm">Delete</button></td> */}
//           </Grid>
//           <Grid item xs={3}>
//           <Button onClick={(e) => deleteUser(e, customerId )}  color="error" size="medium" startIcon={<DeleteIcon color='warning'/>}/>
//           </Grid>
//            </Grid>
//            </ThemeProvider>
//         )
//       },
//     },
//   ];
  

//   return (
//     <div>
//     <Navbar/>
//     <div className = "card px-8 m-5">
//       <div className = "card-header">
//       <div class="d-flex justify-content-between">
//            <h4>Customer Master
//            </h4>
//            <ThemeProvider theme={theme}>
//            <Button component={Link} to="/add-customer" variant='contained' color='apple'>Add Customer</Button>
//            </ThemeProvider>
//       </div>
//       </div>
//       <BootstrapTable keyField='id' data={categorylist} columns={columns} hover condensed
//         pagination={paginationFactory(options)}
//         filter={filterFactory()}
//         overlay={ overlayFactory() }
        
//       />
//     </div>
//     </div>
    
//   )
// }

// export default ShowSerial
